/**
 * Email Verification Guard
 *
 * Prüft ob die Email des Users verifiziert ist.
 * Wenn nicht, wird der User zur /verify-email-pending Seite weitergeleitet.
 *
 * Wird in Kombination mit dem posAuthGuard verwendet.
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take, switchMap, filter } from 'rxjs/operators';

export const emailVerificationGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.user$.pipe(
    // Warte auf User (nicht null)
    filter(user => user !== null),
    take(1),
    map(user => {
      if (user?.emailVerified) {
        // Email ist verifiziert → Zugang erlaubt
        return true;
      }

      // Email nicht verifiziert → Redirect zu Pending-Seite
      console.log('[EmailVerificationGuard] Email nicht verifiziert, redirect zu /verify-email-pending');
      router.navigate(['/verify-email-pending']);
      return false;
    })
  );
};
